import isInternalOrExternalNote from "./isInternalOrExternalNote";

export default (notesType, defaultFieldName = "body") => {
  if (notesType && isInternalOrExternalNote(notesType)) {
    return `${notesType}_note`;
  }

  return defaultFieldName;
};



// WEBPACK FOOTER //
// ./app/modules/shared/components/Notes/getNoteBodyFieldName.js